/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Push_Clicktounsubscribe2Inputs */

const id_notifications_push_clicktounsubscribe2 = /** @type {(inputs: Notifications_Push_Clicktounsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klik pada topik untuk berhenti berlangganan`)
};

const ms_notifications_push_clicktounsubscribe2 = /** @type {(inputs: Notifications_Push_Clicktounsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klik pada topik untuk berhenti melanggan`)
};

const da_notifications_push_clicktounsubscribe2 = /** @type {(inputs: Notifications_Push_Clicktounsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klik på et emne for at afmelde`)
};

const de_notifications_push_clicktounsubscribe2 = /** @type {(inputs: Notifications_Push_Clicktounsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klicken Sie auf ein Thema, um die Abmeldung durchzuführen`)
};

const en_us2_notifications_push_clicktounsubscribe2 = /** @type {(inputs: Notifications_Push_Clicktounsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click on a topic to unsubscribe`)
};

const es_es2_notifications_push_clicktounsubscribe2 = /** @type {(inputs: Notifications_Push_Clicktounsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haz clic en un tema para desuscribirte`)
};

const es_mx2_notifications_push_clicktounsubscribe2 = /** @type {(inputs: Notifications_Push_Clicktounsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haz clic en un tema para cancelar la suscripción`)
};

const fil_notifications_push_clicktounsubscribe2 = /** @type {(inputs: Notifications_Push_Clicktounsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-click ang isang paksa upang mag-unsubscribe`)
};

const fr_notifications_push_clicktounsubscribe2 = /** @type {(inputs: Notifications_Push_Clicktounsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cliquez sur un sujet pour vous désabonner`)
};

const it_notifications_push_clicktounsubscribe2 = /** @type {(inputs: Notifications_Push_Clicktounsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clicca su un argomento per annullare l'iscrizione`)
};

const hu_notifications_push_clicktounsubscribe2 = /** @type {(inputs: Notifications_Push_Clicktounsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kattints egy témára a leiratkozáshoz`)
};

const nl_notifications_push_clicktounsubscribe2 = /** @type {(inputs: Notifications_Push_Clicktounsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klik op een onderwerp om uit te schrijven`)
};

const no_notifications_push_clicktounsubscribe2 = /** @type {(inputs: Notifications_Push_Clicktounsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klikk på et emne for å melde deg av`)
};

const pl_notifications_push_clicktounsubscribe2 = /** @type {(inputs: Notifications_Push_Clicktounsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kliknij na temat, aby wypisać się`)
};

const pt_br2_notifications_push_clicktounsubscribe2 = /** @type {(inputs: Notifications_Push_Clicktounsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click on a topic to unsubscribe`)
};

const pt_notifications_push_clicktounsubscribe2 = /** @type {(inputs: Notifications_Push_Clicktounsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clique num tópico para cancelar a subscrição`)
};

const ro_notifications_push_clicktounsubscribe2 = /** @type {(inputs: Notifications_Push_Clicktounsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fă clic pe un subiect pentru a te dezabona`)
};

const fi_notifications_push_clicktounsubscribe2 = /** @type {(inputs: Notifications_Push_Clicktounsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Napsauta aihetta peruuttaaksesi tilauksen`)
};

const sv_notifications_push_clicktounsubscribe2 = /** @type {(inputs: Notifications_Push_Clicktounsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klicka på ett ämne för att avsluta prenumerationen`)
};

const vi_notifications_push_clicktounsubscribe2 = /** @type {(inputs: Notifications_Push_Clicktounsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhấp vào chủ đề để hủy đăng ký`)
};

const tr_notifications_push_clicktounsubscribe2 = /** @type {(inputs: Notifications_Push_Clicktounsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonelikten çıkmak için bir konuya tıklayın`)
};

const cs_notifications_push_clicktounsubscribe2 = /** @type {(inputs: Notifications_Push_Clicktounsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kliknutím na téma se odhlásíte`)
};

const bg_notifications_push_clicktounsubscribe2 = /** @type {(inputs: Notifications_Push_Clicktounsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Щракнете върху тема, за да се отпишете`)
};

const ru_notifications_push_clicktounsubscribe2 = /** @type {(inputs: Notifications_Push_Clicktounsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нажмите на тему, чтобы отписаться`)
};

const uk_notifications_push_clicktounsubscribe2 = /** @type {(inputs: Notifications_Push_Clicktounsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Натисніть на тему, щоб відписатися`)
};

const ar_notifications_push_clicktounsubscribe2 = /** @type {(inputs: Notifications_Push_Clicktounsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انقر على موضوع لإلغاء الاشتراك`)
};

const hi_notifications_push_clicktounsubscribe2 = /** @type {(inputs: Notifications_Push_Clicktounsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सब्सक्रिप्शन रद्द करने के लिए क्लिक करें`)
};

const th_notifications_push_clicktounsubscribe2 = /** @type {(inputs: Notifications_Push_Clicktounsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คลิกที่หัวข้อเพื่อยกเลิกการสมัคร`)
};

const ja_notifications_push_clicktounsubscribe2 = /** @type {(inputs: Notifications_Push_Clicktounsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トピックをクリックして購読解除`)
};

const zh_cn2_notifications_push_clicktounsubscribe2 = /** @type {(inputs: Notifications_Push_Clicktounsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click on a topic to unsubscribe`)
};

const zh_hant1_notifications_push_clicktounsubscribe2 = /** @type {(inputs: Notifications_Push_Clicktounsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click on a topic to unsubscribe`)
};

const ko_notifications_push_clicktounsubscribe2 = /** @type {(inputs: Notifications_Push_Clicktounsubscribe2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`클릭하여 구독 취소`)
};

/**
* | output |
* | --- |
* | "Click on a topic to unsubscribe" |
*
* @param {Notifications_Push_Clicktounsubscribe2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_push_clicktounsubscribe2 = /** @type {((inputs?: Notifications_Push_Clicktounsubscribe2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Push_Clicktounsubscribe2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_push_clicktounsubscribe2(inputs)
	if (locale === "ms") return ms_notifications_push_clicktounsubscribe2(inputs)
	if (locale === "da") return da_notifications_push_clicktounsubscribe2(inputs)
	if (locale === "de") return de_notifications_push_clicktounsubscribe2(inputs)
	if (locale === "en-US") return en_us2_notifications_push_clicktounsubscribe2(inputs)
	if (locale === "es-ES") return es_es2_notifications_push_clicktounsubscribe2(inputs)
	if (locale === "es-MX") return es_mx2_notifications_push_clicktounsubscribe2(inputs)
	if (locale === "fil") return fil_notifications_push_clicktounsubscribe2(inputs)
	if (locale === "fr") return fr_notifications_push_clicktounsubscribe2(inputs)
	if (locale === "it") return it_notifications_push_clicktounsubscribe2(inputs)
	if (locale === "hu") return hu_notifications_push_clicktounsubscribe2(inputs)
	if (locale === "nl") return nl_notifications_push_clicktounsubscribe2(inputs)
	if (locale === "no") return no_notifications_push_clicktounsubscribe2(inputs)
	if (locale === "pl") return pl_notifications_push_clicktounsubscribe2(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_push_clicktounsubscribe2(inputs)
	if (locale === "pt") return pt_notifications_push_clicktounsubscribe2(inputs)
	if (locale === "ro") return ro_notifications_push_clicktounsubscribe2(inputs)
	if (locale === "fi") return fi_notifications_push_clicktounsubscribe2(inputs)
	if (locale === "sv") return sv_notifications_push_clicktounsubscribe2(inputs)
	if (locale === "vi") return vi_notifications_push_clicktounsubscribe2(inputs)
	if (locale === "tr") return tr_notifications_push_clicktounsubscribe2(inputs)
	if (locale === "cs") return cs_notifications_push_clicktounsubscribe2(inputs)
	if (locale === "bg") return bg_notifications_push_clicktounsubscribe2(inputs)
	if (locale === "ru") return ru_notifications_push_clicktounsubscribe2(inputs)
	if (locale === "uk") return uk_notifications_push_clicktounsubscribe2(inputs)
	if (locale === "ar") return ar_notifications_push_clicktounsubscribe2(inputs)
	if (locale === "hi") return hi_notifications_push_clicktounsubscribe2(inputs)
	if (locale === "th") return th_notifications_push_clicktounsubscribe2(inputs)
	if (locale === "ja") return ja_notifications_push_clicktounsubscribe2(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_push_clicktounsubscribe2(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_push_clicktounsubscribe2(inputs)
	return ko_notifications_push_clicktounsubscribe2(inputs)
});
export { notifications_push_clicktounsubscribe2 as "notifications.push.clickToUnsubscribe" }